import React from 'react'
import Modal from '@material-ui/core/Modal'

export default function ImageModal({ open, onClose, children }) {
  return (
    <Modal open={open} onClose={onClose}>
      {children}
    </Modal>
  )
}
